export enum PaymentMethod {
    CREDIT_CARD = 'CREDIT_CARD',
    IDEAL = 'IDEAL',
    SOFORT = 'SOFORT',
    BANCONTACT = 'BANCONTACT',
    MANUAL = 'MANUAL',
    MANDATE = 'MANDATE'
}